<template>
  <messenger-chat
    v-if="conversation"
    :conversation="conversation">
  </messenger-chat>
  <span v-else>loading</span>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { MessengerChat } from '@/components/messenger'
  export default {
    components: {
      MessengerChat
    },
    props: {
      id: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        conversations: 'skiliko/conversations/collection'
      }),
      conversation () {
        return this.conversations[this.id]
      }
    },
    methods: mapActions({
      fetch: 'skiliko/conversations/fetch'
    }),
    mounted () {
      this.fetch({ id: this.id })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/MessengerMessage.vue